import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import './Nav.css';

function Nav() {

  var check_nav = true;

  const show_menu = () =>{

    if(check_nav === true){ 

      setTimeout(()=>{
        document.querySelector(".Menu_mobile").classList.remove('close');
        document.querySelector(".Menu_mobile").classList.add('open');
      },100)

      document.querySelector(".Menu_mobile").style.display = "none";
      document.querySelector(".Menu_mobile").style.display = "flex";
      document.querySelector(".menu").src = "assets/icons/close.svg";
      document.body.style.overflow = "hidden";
      return check_nav = false;
    }
    else{
      document.querySelector(".Menu_mobile").classList.remove('open');
      document.querySelector(".Menu_mobile").classList.add('close');
      document.querySelector(".menu").src = "assets/icons/menu.svg";
      document.body.style.overflow = "auto";

      setTimeout(()=>{
        document.querySelector(".Menu_mobile").style.display = "none";
      },700)

      return check_nav = true;
    }


  }



  return (  
    <div id='Home' className="nav-content">

      <img className='menu' src='assets/icons/menu.svg' alt='menu' onClick={show_menu} />
      <ScrollLink to="Contact" smooth={true} duration={500} className="lien">
        <strong>تواصلوا معنا</strong>
      </ScrollLink>
      <ScrollLink to="donate" smooth={true} duration={500} className="lien">
        <strong>للتبرع</strong>
      </ScrollLink>
      <RouterLink to="/">
        <img src="Le_logo.png" className="nav_logo" alt="1" />
      </RouterLink>
      <ScrollLink to="Details" smooth={true} duration={500} className="lien">
        <strong>تفاصيل المشروع</strong>
      </ScrollLink>
      <RouterLink to="/" className="lien">
        <strong>الرئيسية</strong>
      </RouterLink>

      <div className='Menu_mobile'>

        <div className='menu_container'>

          <ScrollLink onClick={show_menu} to="Home" className="lien">
            <strong>الرئيسية</strong>
          </ScrollLink>
          <ScrollLink onClick={show_menu} to="Details" smooth={true} duration={500} className="lien">
            <strong>تفاصيل المشروع</strong>
          </ScrollLink>
          <ScrollLink onClick={show_menu} to="donate" smooth={true} duration={500} className="lien">
            <strong>للتبرع</strong>
          </ScrollLink>
          <ScrollLink onClick={show_menu} to="Contact" smooth={true} duration={500} className="lien">
            <strong>تواصلوا معنا</strong>
          </ScrollLink>

        </div>

      </div>

    </div>
  );
}

export default Nav;
